// src/api/serviceReports.js
// CRA-safe: uses process.env only (REACT_APP_*). No import.meta anywhere.

const BASE = (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE) || "";
// Alias base: your server already rewrites /api/sr/* -> /api/service-reports/*
const SR_BASE =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_SR_BASE) ||
  "/api/service-reports";

async function req(path, opts = {}) {
  const init = {
    method: opts.method || "GET",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    credentials: "include",
  };
  if (opts.body !== undefined) {
    init.body = typeof opts.body === "string" ? opts.body : JSON.stringify(opts.body);
  }

  const res = await fetch(`${BASE}${SR_BASE}${path}`, init);
  if (!res.ok) {
    let msg = `${res.status}`;
    try {
      const j = await res.json();
      if (j && j.error) msg = `${msg} ${j.error}`;
    } catch {}
    throw new Error(msg);
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res.text();
}

export const sr = {
  engineers: {
    list: () => req("/engineers"),
    add: (payload) => req("/engineers", { method: "POST", body: payload }),
    update: (id, payload) => req(`/engineers/${id}`, { method: "PUT", body: payload }),
    remove: (id) => req(`/engineers/${id}`, { method: "DELETE" }),
  },
  tasks: {
    list: () => req("/tasks"),
    add: (payload) => req("/tasks", { method: "POST", body: payload }),
    update: (id, payload) => req(`/tasks/${id}`, { method: "PUT", body: payload }),
    remove: (id) => req(`/tasks/${id}`, { method: "DELETE" }),
  },
  // Report templates
  templates: {
    list: (all = false) => req(`/templates${all ? "?all=1" : ""}`),
    get:  (id) => req(`/templates/${id}`),
    add:  (payload) => req("/templates", { method: "POST", body: payload }),
    update: (id, payload) => req(`/templates/${id}`, { method: "PUT", body: payload }),
    setTasks: (id, tasks) =>
      req(`/templates/${id}/tasks`, { method: "PUT", body: { tasks } }),
  },
  reports: {
    list: () => req("/reports"),
    create: (payload) => req("/reports", { method: "POST", body: payload }),
    pdfUrl: (id) => `${BASE}${SR_BASE}/reports/${id}/pdf`,
  },
};
